(function () {
  'use strict';

  function formatMoney(amount, currency) {
    if (amount === null || amount === undefined || amount === '' || Number.isNaN(Number(amount))) return '';
    try {
      return new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: currency || 'DKK',
        minimumFractionDigits: Number(amount) % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(Number(amount));
    } catch (_) {
      return String(amount) + ' ' + (currency || 'DKK');
    }
  }

  function formatDkkLabel(amount, currency) {
    if (amount === null || amount === undefined || amount === '' || Number.isNaN(Number(amount))) return '';
    var rounded = Number(amount);
    var number = new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: rounded % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(rounded);
    return number + ' ' + String(currency || 'DKK').toUpperCase();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeBuyRoute(value) {
    var route = String(value || '').trim();
    return /^\/buy(?:[/?#]|$)/.test(route) ? route : '';
  }

  function giftPresentation(card) {
    var raw = [card && card.name, card && card.variant_name].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
    var ticket = raw.match(/\b(\d+)\s*TICKETS?\b/i);
    var amountLabel = formatDkkLabel(card && card.amount, card && card.currency);
    var detail = String((card && card.description) || '').trim();

    if (ticket) {
      var count = Number(ticket[1]);
      return {
        kicker: 'SESSION GIFT',
        title: count + ' ' + (count === 1 ? 'SESSION' : 'SESSIONS'),
        price: amountLabel || 'DIGITAL GIFT',
        detail: detail || 'A digital Plugin Heat Club gift for one or more sessions.'
      };
    }

    if (amountLabel) {
      return {
        kicker: 'VALUE GIFT',
        title: amountLabel + ' GIFT CARD',
        price: 'DIGITAL DELIVERY',
        detail: detail || 'Let them choose the Plugin ritual and session that fits them.'
      };
    }

    var cleaned = raw
      .replace(/\bEMAIL\b/ig, '')
      .replace(/\bDIGITAL\b/ig, '')
      .replace(/\bGIFT\s*CARD\b/ig, '')
      .replace(/[–—-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return {
      kicker: 'DIGITAL GIFT',
      title: (cleaned || 'PLUGIN') + ' GIFT CARD',
      price: 'EMAIL DELIVERY',
      detail: detail || 'A digital gift delivered through Plugin Heat Club’s secure checkout.'
    };
  }

  function setup(root) {
    if (!root || root.dataset.phcGiftReady === '1') return;
    root.dataset.phcGiftReady = '1';

    var proxy = (root.dataset.proxyUrl || '').trim();
    var list = root.querySelector('[data-phc-gifts-list]');
    var loading = root.querySelector('[data-phc-gifts-loading]');
    var error = root.querySelector('[data-phc-gifts-error]');
    var checkout = root.querySelector('[data-phc-gifts-checkout]');
    var fallbackButtons = root.querySelectorAll('[data-phc-gifts-open-fallback]');
    var dialog = root.querySelector('[data-phc-gift-dialog]');
    var close = root.querySelector('[data-phc-gift-close]');
    var integration = dialog && dialog.querySelector('[data-phc-native-booking-integration]');
    var modalLoading = dialog && dialog.querySelector('[data-phc-gift-modal-loading]');
    var selection = dialog && dialog.querySelector('[data-phc-gift-selection]');
    var selectionName = dialog && dialog.querySelector('[data-phc-gift-selection-name]');
    var selectionPrice = dialog && dialog.querySelector('[data-phc-gift-selection-price]');
    var observer = null;

    function currentMarianaRoute() {
      return String(new URL(window.location.href).searchParams.get('_mt') || '').trim();
    }

    function storedContext() {
      try {
        var context = JSON.parse(sessionStorage.getItem('phc:gift-context') || 'null');
        if (!context || typeof context !== 'object') return null;
        var createdAt = Number(context.createdAt || 0);
        if (!createdAt || Date.now() - createdAt > 2 * 60 * 60 * 1000) return null;
        if (context.pathname && String(context.pathname) !== window.location.pathname) return null;
        if (!safeBuyRoute(context.route)) return null;
        return context;
      } catch (_) {
        return null;
      }
    }

    function watchIntegration() {
      if (!integration || !modalLoading) return;
      modalLoading.hidden = false;
      var ready = function () {
        var hasFrame = Boolean(integration.querySelector('iframe'));
        var hasContent = integration.children.length > 0 || String(integration.textContent || '').trim().length > 24;
        if (!hasFrame && !hasContent) return false;
        modalLoading.hidden = true;
        if (observer) observer.disconnect();
        observer = null;
        return true;
      };
      if (ready()) return;
      if (observer) observer.disconnect();
      observer = new MutationObserver(ready);
      observer.observe(integration, { childList: true, subtree: true, characterData: true });
    }

    function showDialogFromRoute() {
      var url = new URL(window.location.href);
      var marianaRoute = currentMarianaRoute();
      var buyRoute = safeBuyRoute(marianaRoute);
      var isCallback = /^\/callback(?:[/?#]|$)/.test(marianaRoute);
      var context = storedContext();
      var callbackBelongsToGift = isCallback && (url.searchParams.get('phc_gift') === '1' || Boolean(context));
      if ((!buyRoute && !callbackBelongsToGift) || !dialog) return;

      // Keep the native Mariana host mounted while Mariana consumes an OAuth
      // callback. The selected gift context is same-origin sessionStorage only;
      // code/state remain untouched and owned by Mariana.
      if (selection) selection.hidden = !context;
      if (context) {
        if (selectionName) selectionName.textContent = context.name || 'Gift card';
        if (selectionPrice) selectionPrice.textContent = context.price || '';
      }

      watchIntegration();
      if (typeof dialog.showModal === 'function') {
        try { if (!dialog.open) dialog.showModal(); } catch (_) {}
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('phc-modal-open');
    }

    function openSecureCheckout(route, card, presentation) {
      route = safeBuyRoute(route);
      if (!route) return;

      try {
        if (card && card.purchase_route_verified === true) {
          sessionStorage.setItem('phc:gift-context', JSON.stringify({
            route: route,
            pathname: window.location.pathname,
            createdAt: Date.now(),
            productId: String(card.id || ''),
            variantId: String(card.variant_id || ''),
            name: presentation.title,
            price: formatMoney(card.amount, card.currency)
          }));
        } else {
          sessionStorage.removeItem('phc:gift-context');
        }
      } catch (_) {}

      // Full navigation is deliberate: Mariana owns customer/auth/payment state.
      // We never destroy/recreate an already running integration in-place.
      var url = new URL(window.location.href);
      url.searchParams.set('_mt', route);
      url.searchParams.set('phc_gift', '1');
      window.location.assign(url.toString());
    }

    function closeDialog() {
      if (observer) observer.disconnect();
      observer = null;
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        try { dialog.close(); } catch (_) {}
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.classList.remove('phc-modal-open');
      var url = new URL(window.location.href);
      url.searchParams.delete('_mt');
      url.searchParams.delete('phc_gift');
      try { sessionStorage.removeItem('phc:gift-context'); } catch (_) {}
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    if (close) close.addEventListener('click', closeDialog);
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeDialog();
      });
    }

    fallbackButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openSecureCheckout(safeBuyRoute(root.dataset.buyRoute) || '/buy', null, null);
      });
    });

    function render(cards) {
      if (!list) return;
      list.innerHTML = cards.map(function (card, index) {
        var presentation = giftPresentation(card);
        var exactRoute = card && card.purchase_route_verified === true ? safeBuyRoute(card.purchase_route) : '';
        var cardNumber = String(index + 1).padStart(2, '0');
        return '<article class="phc-native-gift" data-phc-gift-index="' + index + '" data-card-number="' + cardNumber + '">' +
          '<div class="phc-native-gift__topline"><span>' + escapeHtml(presentation.kicker) + '</span><em>' + escapeHtml(presentation.price) + '</em></div>' +
          '<h3 class="phc-native-gift__title">' + escapeHtml(presentation.title) + '</h3>' +
          '<p class="phc-native-gift__desc">' + escapeHtml(presentation.detail) + '</p>' +
          '<div class="phc-native-gift__action">' +
            '<button type="button" class="phc-button" data-phc-gift-buy="' + index + '">' +
              (exactRoute ? 'BUY THIS GIFT' : 'CONTINUE TO GIFT CHECKOUT') +
            '</button>' +
            (!exactRoute ? '<p class="phc-native-gift__route-note">FINAL GIFT SELECTION CONTINUES IN THE SECURE CHECKOUT.</p>' : '') +
          '</div>' +
        '</article>';
      }).join('');
      list.hidden = false;
      if (checkout) checkout.hidden = false;

      list.querySelectorAll('[data-phc-gift-buy]').forEach(function (button) {
        button.addEventListener('click', function () {
          var idx = Number(button.getAttribute('data-phc-gift-buy'));
          var card = cards[idx] || null;
          if (!card) return;

          var exactRoute = card.purchase_route_verified === true ? safeBuyRoute(card.purchase_route) : '';
          if (exactRoute) {
            openSecureCheckout(exactRoute, card, giftPresentation(card));
            return;
          }

          openSecureCheckout(safeBuyRoute(root.dataset.buyRoute) || '/buy', null, null);
        });
      });
    }

    // Re-open a Mariana-owned /buy route after login/OAuth even if PHC's own
    // phc_gift marker was dropped during the redirect. `_mt` is authoritative.
    showDialogFromRoute();

    if (!proxy) {
      if (loading) loading.hidden = true;
      if (error) error.hidden = false;
      return;
    }

    fetch(proxy + (proxy.indexOf('?') === -1 ? '?' : '&') + 'action=gift-cards', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'omit'
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.detail || body.error || 'Gift card request failed');
          return body;
        });
      })
      .then(function (body) {
        var cards = Array.isArray(body.gift_cards) ? body.gift_cards : [];
        if (!cards.length) throw new Error('No gift cards returned by Mariana');
        render(cards);
        if (loading) loading.hidden = true;
        if (error) error.hidden = true;
      })
      .catch(function (err) {
        console.warn('[PHC gift cards]', err);
        if (loading) loading.hidden = true;
        if (list) list.hidden = true;
        if (checkout) checkout.hidden = true;
        if (error) error.hidden = false;
      });
  }

  function boot() {
    document.querySelectorAll('[data-phc-native-gifts]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
